import FileService from "../infractions/filesService";
import FilesService from "../office/filesService";
import store from "@/store";
//import { useRouter } from "vue-router";
import { FRONT_URL } from "@/env";

//const router = useRouter();

class GeneralFunctions {
  static async saveFilesOnInfractionsAPI(filesArray, groupCode) {
    let urls = [];

    // Convertimos el foreach en un map y usamos Promise.all
    const uploadPromises = filesArray.map(async (file) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", 1);
      formData.append("action", "stateTransition");

      try {
        const response = await FilesService.saveFile(formData);
        if (response.success) {
          urls.push(response.data.url);
          await FileService.saveFileUrl(response.data.url, groupCode);
        }
      } catch (error) {
        console.log("Error al subir el archivo. Inténtelo de nuevo.", error);
        throw new Error("Error al subir uno o más archivos."); // Lanza un error si falla
      }
    });

    try {
      await Promise.all(uploadPromises); // Esperar a que todas las subidas terminen
      return { success: true, urls };
    } catch (error) {
      return { success: false, message: "error subiendo las imagenes" };
    }
  }

  static async logOutOffice() {
    try {
      const theme = localStorage.getItem("theme");

      localStorage.clear();

      if (theme) {
        localStorage.setItem("theme", theme);
      }

      await store.dispatch("mockOutAction");
      document.cookie = "cidi=; max-age=0";
      document.cookie = "token=; max-age=0";
      document.cookie = "refreshToken=; max-age=0";
      window.dispatchEvent(
        new CustomEvent("token-localstorage-changed", {
          detail: {
            storage: localStorage.getItem("token"),
          },
        }),
      );
      //router.push({ name: "login" });
      //window.location.reload();
      window.location.assign(`${FRONT_URL}/login`);
    } catch (error) {
      console.log("error al cerra sesion");
    }
  }

  static isMobile() {
    // 1. Intenta usar la API moderna (Chrome/Edge)
    if (navigator.userAgentData) {
      return navigator.userAgentData.mobile;
    }

    // 2. Detección para iPad OS 13+ (que finge ser Macintosh)
    // Verifica si es Mac Y si tiene puntos táctiles
    if (navigator.userAgent.includes("Mac") && "ontouchend" in document) {
      return true;
    }

    // 3. Fallback al viejo User Agent (Safari/Firefox/Legacy)
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  }

  static FormatId(value) {
    if (value === undefined || value === null || value === "") return "";

    const stringValue = value.toString().trim();
    if (!stringValue) return "";

    if (/^\d+$/.test(stringValue)) {
      return stringValue.padStart(5, "0");
    }

    return stringValue;
  }

  static formatDate(dateString) {
    if (!dateString) return null;
    return new Date(dateString).toLocaleDateString("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  static formatPrice(
    value,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2,
  ) {
    if (isNaN(value) || value === null) return "$ 0";

    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
    }).format(value);
  }

  static formatNumber(
    value,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2,
  ) {
    if (isNaN(value) || value === null) return "0,00";

    return new Intl.NumberFormat("es-AR", {
      style: "decimal",
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
    }).format(value);
  }

  static manageBlob(
    blob,
    fileName = "comprobante.pdf",
    shouldDownload = true,
    mimeType = "application/pdf",
  ) {
    const fileBlob = new Blob([blob], { type: mimeType });
    const url = window.URL.createObjectURL(fileBlob);

    if (shouldDownload) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } else {
      const newWindow = window.open(url, "_blank");

      if (!newWindow) {
        console.warn(
          "El navegador bloqueó la pestaña nueva. Forzando descarga en su lugar.",
        );
        this.manageBlob(blob, fileName, true, mimeType);
        return;
      }

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 10000);
    }
  }

  static formatShortName({ firstname, lastname }) {
    if (!firstname) return "Desconocido";

    const nombre = firstname?.trim().split(" ")[0] || "";

    const apellido = lastname?.trim() || "";

    return `${nombre} ${apellido}`.trim();
  }
}

export default GeneralFunctions;
